
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import ReactSelect from 'react-select'
import './styles.scss'
import '../../styles/index.scss'
import { reaction } from 'mobx'
import { NONE_CIRCUMSTANCES_VALUE } from '../../constants'

class Select extends Component {
  formatOptions (options) {
    let opts = options
    opts = opts.map((o) => {
      return {
        label: o.text,
        value: o.value
      }
    })
    return opts
  }

  componentDidMount() {
    const { Store: FAAStore } = this.props;
    this.disposeTemporaryLossReaction = reaction(
      () => FAAStore.receiveCharityCareSelected,
      (isSelected) => {
        if (!isSelected) {
          FAAStore.resetAttachements()
        }
      }
    )
  }

  componentWillUnmount() {
    if (this.dispose) this.dispose()
  }

  enforceNoneExclusivity (fieldName, newValue, prevValue) {
    if (fieldName !== 'circumstance' || !newValue) return newValue

    const newValues = newValue.split(',')
    const prevValues = prevValue ? prevValue.split(',') : []
    const noneIsNew = newValues.includes(NONE_CIRCUMSTANCES_VALUE) && !prevValues.includes(NONE_CIRCUMSTANCES_VALUE)
    if (noneIsNew) {
      return NONE_CIRCUMSTANCES_VALUE
    }
    if (prevValues.includes(NONE_CIRCUMSTANCES_VALUE) && newValues.includes(NONE_CIRCUMSTANCES_VALUE) && newValues.length > 1) {
      return newValues.filter(v => v !== NONE_CIRCUMSTANCES_VALUE).join(',')
    }
    return newValue
  }

  handleOnChange (name, e) {
    const { onChangeValidationFunction = [], Store: FAAStore } = this.props
    if (!e) e = ''
    const value = FAAStore.getValue(name)
    e = this.enforceNoneExclusivity(name, e, value)
    FAAStore.updateFieldValue(name, e)
    FAAStore.temporaryLossSelected = /7/.test(e)
    FAAStore.permanentLossSelected = /8/.test(e)
    FAAStore.otherCircumstancesSelected = /12/.test(e)
    FAAStore.receiveCharityCareSelected = /15/.test(e)
    let isValid = true
    onChangeValidationFunction.forEach(funct => {
      if (!funct(name, e)) isValid = false
    })
    FAAStore.updateFieldError(name, !isValid)
  }

  render () {
    const {
      name,
      placeholder = '',
      options,
      className,
      id,
      isMultiple = false,
      simpleValue = false,
      delimiter = '',
      joinValues = false,
      automationName,
      Store: FAAStore
    } = this.props

    const selectError = FAAStore.hasError(name)
    const wraperClass = selectError ? 'form-group select-error' : 'form-group'
    return (
      <div data-automation-name={automationName} className={wraperClass} id={id}>
        <ReactSelect
          name={name}
          value={FAAStore.getValue(name)}
          onChange={(e) => this.handleOnChange(name, e)}
          className={className}
          options={this.formatOptions(options)}
          multi={isMultiple}
          simpleValue={simpleValue}
          delimiter={delimiter}
          joinValues={joinValues}
          placeholder={placeholder}
        />
      </div>
    )
  }
}

Select.defaultProps = {
  placeholder: ''
}

Select.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string
}

export default observer(Select)
